import { apiSlice } from '../app/api/apiSlice';
import queryString from 'query-string';


export const PaymentToolApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    getTransactionTypes: builder.query({
      query: () => `/Transaction/types`,
    }),
    getTransactions: builder.query({
      query: (query = {}) => {
        let queryString = Object.entries(query).reduce((p, [key, value]) => {
          if (Array.isArray(value)) {
            return p + value.map(v => `${key}=${v}`).join('&') + '&';
          }
          return p + `${key}=${value}&`;
        }, ''); 

        return ({url: '/Transaction/?' + queryString.slice(0, -1), method: 'Get'})
      },
      providesTags: ['transactions']
    }),
    getTransactionsPaged: builder.query({
      query: (query) => `/Transaction/paged?` + queryString.stringify(query),
      providesTags: ['transactionsPaged'],
    }),
    createTransactionAdjustment: builder.mutation({
      query: (body) => ({
        url: `/Transaction/adjustments`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['transactions', 'userMetrics', 'transactionSummary', 'transactionsPaged'],
    }),
    editTransactionAdjustment: builder.mutation({
      query: (body) => ({
        url: `/Transaction/adjustments`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['transactions', 'userMetrics', 'transactionSummary', 'transactionsPaged'],
    }),
    closePeriod: builder.mutation({
      query: (body) => ({
        url: `/Transaction/close-period`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['period', 'yearMetrics', 'yearMetricsSummary', 'periodMetrics', 'transactionSummary'],
    }),
    getYearMetrics: builder.query({
      query: (query) => `/Transaction/year-metrics?` + queryString.stringify(query),
      providesTags: ['yearMetrics']
    }),
    getYearMetricsSummary: builder.query({
      query: (query) => `/Transaction/year-metrics-summary?` + queryString.stringify(query),
      providesTags: ['yearMetricsSummary']
    }),
    GetTransactionSummary: builder.query({
      query: (query) => `/Transaction/summary?` + queryString.stringify(query),
      providesTags: ['transactionSummary']
    }),
    getPeriodMetrics: builder.query({
      query: (query) => `/Transaction/period-metrics?` + queryString.stringify(query),
      providesTags: ['periodMetrics']
    }),
    getUserMetrics: builder.query({
      query: (query) => `/Transaction/user-metrics?` + queryString.stringify(query),
      providesTags: ['userMetrics']
    }),
    getPeriod: builder.query({
      query: (query) => `/Transaction/period?` + queryString.stringify(query),
      providesTags: ['period']
    }),
    sendPayments: builder.mutation({
      query: (body) => ({
        url: `/Transaction/send-payments`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['period', 'yearMetrics', 'yearMetricsSummary', 'periodMetrics'],
    }),
    getValidatePaymentData: builder.query({
      query: (query) => `/Transaction/validate-payment-data?` + queryString.stringify(query),
      providesTags: ['validate-payment-data']
    }),
    getPaymentStatus: builder.query({
      query: (query) => `/Transaction/payment-status?` + queryString.stringify(query),
      providesTags: ['payment-status']
    //GET all periods
    }),
    getPeriods: builder.query({
      query: (query) => `/Transaction/periods?` + queryString.stringify(query),
      providesTags: ['periods']
    }),
    getTransactionDetails: builder.query({
      query: ({ transactionID, fields }) => {
        const query = queryString.stringify({ fields });
        return `/Transaction/details/${transactionID}?${query}`;
      },
      providesTags: ['transactionDetails']
    }),
    cancelPayment: builder.mutation({
      query: (body) => ({
        url: `/Transaction/cancel-payment`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['period', 'yearMetrics', 'yearMetricsSummary', 'periodMetrics', 'payment-status'],
    }),
  })
})

export const { useGetTransactionTypesQuery, 
  useCreateTransactionAdjustmentMutation, 
  useGetTransactionsQuery, 
  useLazyGetTransactionsQuery,
  useEditTransactionAdjustmentMutation, 
  useGetYearMetricsQuery, 
  useGetYearMetricsSummaryQuery,
  useGetTransactionSummaryQuery,
  useGetPeriodMetricsQuery,
  useGetUserMetricsQuery,
  useClosePeriodMutation,
  useGetPeriodQuery,
  useGetTransactionsPagedQuery,
  useSendPaymentsMutation,
  useGetValidatePaymentDataQuery,
  useGetPaymentStatusQuery,
  useGetPeriodsQuery,
  useCancelPaymentMutation,
  useGetTransactionDetailsQuery,
} = PaymentToolApi;